import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "animate.css";

import "./Main.css";
import Footer from "./Footer";
// import BlogFetch from "./components/BlogFetch";
function Main() {
  return (
    <div className="container">
      <div className="landing">
        <br />
        <h1 className="title fw-bolder animate__animated animate__shakeY">
          All Green - Tree Counter
        </h1>
        <br />
        <img src="tree.jpg" alt="Treee!" className="img-fluid" />
        <div className="content">
          <h3 className="greet">Welcome! Let's grow trees together</h3>
          <h2>
            We have built this amazing platform to count the trees planted! Join
            this amazing community and make the world <b>Lush Green</b> again 🎉
          </h2>
          <h4 className="hashtag">
            <a
              href="https://twitter.com/intent/tweet?text=Hello%21%20I%20have%20planted%20a%20new%20tree%20with%20the%20help%20of%20%0Ahttps%3A%2F%2Fall-green.netlify.app%2F%20%F0%9F%8E%89%0A%0A%23growplants&original_referer=https://clicktotweet.com&related=clicktotweet"
              target="_blank"
              rel="noreferrer noopener"
            >
              #ALLGREEN
            </a>
          </h4>
          <br />
          <Link to="/rule" className="link">
            <button className="btnn info">Let's Go</button>
          </Link>
        </div>

        {/* <BlogFetch /> */}
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
}
export default Main;
